import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropActions from "@/components/waves/drops/WaveDropActions";
interface MemeDropActionsProps {
  readonly drop: ExtendedDrop;
  readonly isMobile: boolean;
  readonly showReplyAndQuote: boolean;
  readonly onReply: () => void;
}
export default function MemeDropActions(t0) {
  const $ = _c(3);
  const {
    drop,
    isMobile,
    showReplyAndQuote,
    onReply
  } = t0;
  if (isMobile || !showReplyAndQuote) {
    return null;
  }
  let t1;
  if ($[0] !== drop || $[1] !== onReply) {
    t1 = <WaveDropActions drop={drop} activePartIndex={0} onReply={onReply} />;
    $[0] = drop;
    $[1] = onReply;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}